import {
  Box,
  Button,
  Checkbox,
  Flex,
  Table,
  TableTbody,
  TableTd,
  TableTh,
  TableThead,
  TableTr,
  Title,
} from '@mantine/core';

import { WithRecords } from '../wrappers/WithRecords';
import { page, remove, update } from '../api/apps';
import { IconPencil, IconPlus, IconTrash } from '@tabler/icons-react';
import { useState } from 'react';
import { Date } from '../components/Date';

export const Apps = () => {
  const [showDeleted, setShowDeleted] = useState(false);

  return (
    <Box>
      <Flex justify="space-between" mb="lg" align="center">
        <Title order={3}>Existing applications</Title>
        <Flex align="center" gap="md">
          <Checkbox
            label="Show deleted"
            checked={showDeleted}
            onChange={() => setShowDeleted(!showDeleted)}
          />
          <Button
            component="a"
            color="blue"
            href="/apps/create"
            leftSection={<IconPlus />}
          >
            Add new application
          </Button>
        </Flex>
      </Flex>
      <WithRecords
        getPage={page}
        remove={remove}
        showDeleted={showDeleted}
        removeKey="shortCode"
        filters={showDeleted ? { $showDeleted: 'true' } : {}}
        restore={(token, id) => update(token, id, { deletedAt: null })}
      >
        {(apps, removeItem, restoreItem) => (
          <Table.ScrollContainer minWidth={500}>
            <Table>
              <TableThead>
                <TableTr>
                  <TableTh>Short code</TableTh>
                  <TableTh>Name</TableTh>
                  <TableTh>Created at</TableTh>
                  <TableTh>Updated at</TableTh>
                  <TableTh></TableTh>
                </TableTr>
              </TableThead>
              <TableTbody>
                {apps.map((app) => (
                  <TableTr key={app._id}>
                    <TableTd>{app.shortCode}</TableTd>
                    <TableTd>{app.friendlyName}</TableTd>
                    <TableTd>
                      <Date isoString={app.createdAt} />
                    </TableTd>
                    <TableTd>
                      <Date isoString={app.updatedAt} />
                    </TableTd>
                    <TableTd>
                      <Flex justify="flex-end" gap="md">
                        <Button
                          component="a"
                          color="blue"
                          href={`/apps/${app.shortCode}`}
                          leftSection={<IconPencil />}
                        >
                          Edit
                        </Button>
                        {app.deletedAt ? (
                          <Button
                            color="green"
                            onClick={() => restoreItem(app.shortCode)}
                          >
                            Restore
                          </Button>
                        ) : (
                          <Button
                            leftSection={<IconTrash />}
                            color="red"
                            onClick={() => {
                              if (
                                window.confirm(
                                  `Are you sure you want to remove "${app.friendlyName}"?`
                                )
                              ) {
                                removeItem(app.shortCode);
                              }
                            }}
                          >
                            Remove
                          </Button>
                        )}
                      </Flex>
                    </TableTd>
                  </TableTr>
                ))}
              </TableTbody>
            </Table>
          </Table.ScrollContainer>
        )}
      </WithRecords>
    </Box>
  );
};
